<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.29,8.71C7.47,8.89,7.72,9,8,9C8.280000000000001,9,8.530000000000001,8.89,8.71,8.71C8.71,8.71,12.71,4.71,12.71,4.71C12.89,4.53,13,4.28,13,4C13,3.45,12.55,3,12,3C11.72,3,11.47,3.11,11.29,3.29C11.29,3.29,8,6.59,8,6.59C8,6.59,4.71,3.29,4.71,3.29C4.53,3.11,4.28,3,4,3C3.45,3,3,3.45,3,4C3,4.28,3.11,4.53,3.29,4.71C3.29,4.71,7.29,8.71,7.29,8.71C7.29,8.71,7.29,8.71,7.29,8.71ZM12,8C11.72,8,11.47,8.11,11.29,8.29C11.29,8.29,8,11.59,8,11.59C8,11.59,4.71,8.29,4.71,8.29C4.53,8.11,4.28,8,4,8C3.45,8,3,8.45,3,9C3,9.280000000000001,3.11,9.530000000000001,3.29,9.71C3.29,9.71,7.29,13.71,7.29,13.71C7.47,13.89,7.72,14,8,14C8.280000000000001,14,8.530000000000001,13.89,8.71,13.71C8.71,13.71,12.71,9.71,12.71,9.71C12.89,9.530000000000001,13,9.280000000000001,13,9C13,8.45,12.55,8,12,8C12,8,12,8,12,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoubleChevronDown',
} as DefineComponent
</script>
